import React from 'react'
import { Checkbox, FormControlLabel, withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { defaultC, negativeC, primaryB } from 'asterX-UIkit/constants/colors'

const styledBy = (property, mapping) => props => mapping[props[property]]
const styles = {
	icon: {
		width: 40,
		height: 40,
		borderRadius: 10,
		borderColor: defaultC,
		borderStyle: 'solid',
		border: 1
	},
	checkedIcon: {
		width: 40,
		height: 40,
		borderStyle: 'solid',
		border: 1,
		borderRadius: 10,
		borderColor: defaultC,
		backgroundColor: styledBy('color', {
			primary: primaryB,
			secondary: negativeC
		}),
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	}
}
const StyledCheckbox = withStyles(styles)(({ classes, color, ...other }) => (
	<Checkbox
		{...other}
		checkedIcon={
			<span className={classes.checkedIcon}>
				{color === 'primary' ? (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9 16.1701L4.83 12.0001L3.41 13.4101L9 19.0001L21 7.00009L19.59 5.59009L9 16.1701Z"
							fill="white"
						/>
					</svg>
				) : (
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M0.00235994 1.41313L1.41459 0L8.00013 6.58597L14.5849 0.000753451L15.9972 1.41388L9.41276 7.9987L15.9998 14.5861L14.5875 15.9993L8.00013 9.41143L1.41199 16L-0.000244141 14.5869L6.5875 7.9987L0.00235994 1.41313Z"
							fill="white"
						/>
					</svg>
				)}
			</span>
		}
		icon={<span className={classes.icon} />}
	/>
))

const AsterCheckbox = ({ label, ...props }) => {
	return (
		<FormControlLabel control={<StyledCheckbox {...props} />} label={label} />
	)
}

export default AsterCheckbox

AsterCheckbox.propTypes = {
	color: PropTypes.oneOf(['primary', 'secondary']),
	label: PropTypes.string,
	name: PropTypes.string,
	disabled: PropTypes.bool,
	checked: PropTypes.bool,
	onChange: PropTypes.func
}
